import authRoles from '../../../auth/authRoles';
import React from 'react';
import CompanyReports from './CompanyReports';
import AllergyReports from './Allergy';
import ParentReports from './ParentReports';
import EmergencyContact from './EmergencyContact';
import Staff from './Staff';
import EnrolledStudent from './EnrolledStudent';
import SchoolRoyaltiesReport from './SchoolRoyaltiesReport';
import ImmunizationReport from './ImmunizationReport';


const CompanyReportsConfig = {
	settings: {
		layout: {
			Config: {},
		},
	},
	routes: [
		{
			path: '/company-reports',
			// component: CompanyReports
			element: (
				<React.Suspense fallback={<>...</>}>
					<CompanyReports />
				</React.Suspense>
			),
		},
		{
			path: '/allergy-report',
			// component: AllergyReports,
			element: (
				<React.Suspense fallback={<>...</>}>
					<AllergyReports />
				</React.Suspense>
			),
		},
		{
			path: '/ParentReports',
			// component: ParentReports,
			element: (
				<React.Suspense fallback={<>...</>}>
					<ParentReports />
				</React.Suspense>
			),
		},
		{
			path: '/emergencyContact-report',
			// component: EmergencyContact,
			element: (
				<React.Suspense fallback={<>...</>}>
					<EmergencyContact />
				</React.Suspense>
			),
		},
		{
			path: '/staff-report',
			// component: Staff,
			element: (
				<React.Suspense fallback={<>...</>}>
					<Staff />
				</React.Suspense>
			),
		},
		{
			path: '/enrolledStudent-report',
			// component: EnrolledStudent,
			element: (
				<React.Suspense fallback={<>...</>}>
					<EnrolledStudent />
				</React.Suspense>
			),
		},
		{
			path: '/schoolRoyalties-report',
			// component: SchoolRoyaltiesReport,
			element: (
				<React.Suspense fallback={<>...</>}>
					<SchoolRoyaltiesReport />
				</React.Suspense>
			),
		},
		{
			path: '/immunization-report',
			// component: ImmunizationReport,
			element: (
				<React.Suspense fallback={<>...</>}>
					<ImmunizationReport />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default CompanyReportsConfig;
